import { render, staticRenderFns } from "./ShareVisibilityPolicy.vue?vue&type=template&id=50e90d2d&scoped=true"
import script from "./ShareVisibilityPolicy.vue?vue&type=script&lang=ts"
export * from "./ShareVisibilityPolicy.vue?vue&type=script&lang=ts"
import style0 from "./ShareVisibilityPolicy.vue?vue&type=style&index=0&id=50e90d2d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e90d2d",
  null
  
)

export default component.exports